import React from "react";

const svgProps = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const
};

const IconLayers = () => (
  <svg {...svgProps}>
    <path d="M12 2 2 7l10 5 10-5-10-5Z" />
    <path d="m2 17 10 5 10-5" />
    <path d="m2 12 10 5 10-5" />
  </svg>
);

const IconGitBranch = () => (
  <svg {...svgProps}>
    <line x1="6" y1="3" x2="6" y2="15" />
    <circle cx="18" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M18 9a9 9 0 0 1-9 9" />
  </svg>
);

const IconShield = () => (
  <svg {...svgProps}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const IconTestTube = () => (
  <svg {...svgProps}>
    <path d="M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5V2" />
    <path d="M8.5 2h7" />
    <path d="M14.5 16h-5" />
  </svg>
);

const IconBarChart = () => (
  <svg {...svgProps}>
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

export const BLOCK_ICONS: Record<string, React.FC> = {
  A: IconLayers,
  B: IconGitBranch,
  C: IconShield,
  D: IconTestTube,
  E: IconBarChart
};

export const CHECKPOINT_ICONS: Record<string, React.FC> = {
  "Security exposure": IconShield,
  "Deployment maturity": IconGitBranch,
  "Testing coverage": IconTestTube,
  "Architecture scalability": IconLayers,
  "Business readiness": IconBarChart
};
